import { render, staticRenderFns } from "./ViewTicketModal.vue?vue&type=template&id=2541d13f&scoped=true&"
import script from "./ViewTicketModal.vue?vue&type=script&lang=js&"
export * from "./ViewTicketModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewTicketModal.vue?vue&type=style&index=0&id=2541d13f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2541d13f",
  null
  
)

export default component.exports